<template>
    <div>
        <div class="row my-2 bg-white p-1">
            <div class="col-12 col-md-4 my-2">
                <div>{{ $t('wallets.label.withdraw_type') }}</div>
                <input class="form-control"
                       :value="withdrawTypeStr.get(settlement_withdraw_type)"
                       disabled
                >
            </div>
            <div class="col-12 col-md-4 my-2">
                <div>{{ $t('label.total_amount') }}</div>
                <input class="form-control"
                       :value="total_amount"
                       disabled
                >
            </div>
            <div class="col-12 col-md-4 my-2">
                <div>{{ $t('label.status') }}</div>
                <input :class="`form-control text-white bg-${walletTransactionStatusVariant(status)}`"
                       :value="walletTransactionStatusStr.get(status)"
                       disabled
                >
            </div>
        </div>

        <div v-if="settlement_withdraw_type === withdrawType.INTERNAL">
            <table class="table table-dark">
                <tr>
                    <td v-text="$t('wallets.label.destination_deposit')"></td>
                    <td v-text="$t('label.amount_rial')"></td>
                </tr>
                <tr>
                    <td v-text="settlement_data.destination_deposit"></td>
                    <td v-text="total_amount"></td>
                </tr>
            </table>
        </div>

        <div v-if="settlement_withdraw_type === withdrawType.INTERNAL_GROUP">
            <table class="table table-dark">
                <tr>
                    <td v-text="$t('wallets.label.destination_deposit')"></td>
                    <td v-text="$t('label.amount_rial')"></td>
                </tr>
                <tr v-for="(item, index) in settlement_data.destination_batch_transfers"
                    :key="index"
                >
                    <td v-text="item.destination_deposit_number"></td>
                    <td v-text="item.amount"></td>
                </tr>
            </table>
        </div>

        <div v-if="settlement_withdraw_type === withdrawType.PAYA">
            <table class="table table-dark">
                <tr>
                    <td v-text="$t('wallets.label.destination_iban_number')"></td>
                    <td v-text="$t('wallets.label.destination_owner_name')"></td>
                    <td v-text="$t('label.amount_rial')"></td>
                </tr>
                <tr>
                    <td v-text="settlement_data.iban_number"></td>
                    <td v-text="settlement_data.owner_name"></td>
                    <td v-text="total_amount"></td>
                </tr>
            </table>
        </div>

        <div v-if="settlement_withdraw_type === withdrawType.PAYA_GROUP">
            <table class="table table-dark">
                <tr>
                    <td v-text="$t('wallets.label.destination_iban_number')"></td>
                    <td v-text="$t('wallets.label.destination_owner_name')"></td>
                    <td v-text="$t('label.amount_rial')"></td>
                </tr>
                <tr v-for="(item, index) in settlement_data.transactions"
                    :key="index"
                >
                    <td v-text="item.iban_number"></td>
                    <td v-text="item.owner_name"></td>
                    <td v-text="item.amount"></td>
                </tr>
            </table>
        </div>

        <div v-if="settlement_withdraw_type === withdrawType.SATNA">
            <table class="table table-dark">
                <tr>
                    <td v-text="$t('wallets.label.destination_iban_number')"></td>
                    <td v-text="$t('wallets.label.destination_receiver_name')"></td>
                    <td v-text="$t('wallets.label.destination_receiver_family')"></td>
                    <td v-text="$t('wallets.label.amount_rial_satna_limit')"></td>
                </tr>
                <tr>
                    <td v-text="settlement_data.destination_iban_number"></td>
                    <td v-text="settlement_data.receiver_name"></td>
                    <td v-text="settlement_data.receiver_family"></td>
                    <td v-text="total_amount"></td>
                </tr>
            </table>
        </div>

        <div v-if="settlement_withdraw_type === withdrawType.SATNA_GROUP">
            <table class="table table-dark">
                <tr>
                    <td v-text="$t('wallets.label.destination_iban_number')"></td>
                    <td v-text="$t('wallets.label.destination_receiver_name')"></td>
                    <td v-text="$t('wallets.label.destination_receiver_family')"></td>
                    <td v-text="$t('wallets.label.amount_rial_satna_limit')"></td>
                </tr>
                <tr v-for="(item, index) in settlement_data.transactions"
                    :key="index"
                >
                    <td v-text="item.iban"></td>
                    <td v-text="item.receiver_name"></td>
                    <td v-text="item.receiver_family"></td>
                    <td v-text="item.amount"></td>
                </tr>
            </table>
        </div>
    </div>
</template>

<script>
    import {withdrawType, withdrawTypeStr} from "@/constants/withdrawType";
    import {walletTransactionStatus, walletTransactionStatusStr, walletTransactionStatusVariant} from "@/constants/walletTransactionStatus";

    export default {
        data() {
            return {
                withdrawType,
                withdrawTypeStr,
                walletTransactionStatus,
                walletTransactionStatusStr,
                walletTransactionStatusVariant,
            }
        },
        props: {
            settlement_withdraw_type: {
                required: true,
            },
            settlement_data: {
                required: true,
            },
            total_amount: {
                required: true,
            },
            status: {
                required: true,
            },
        },
    }
</script>
